// removed by extract-text-webpack-plugin
module.exports = {"tabs__link":"lLYqmLbvS7YDnE4CaPC5n","tabs__btn":"_1NaQZ-x_bRLbcrrGloFMiS","active":"AyZg1-FGmlnDv9cie0gf-","notice":"aCFVVIgCqwm-ejEPDOS00","button":"_3T59agqT4MwxYQ5MzMMH_w","intent-primary":"_2PMc3sN--kv2Z5owb8ciZm","lecture-tabs":"_3SayKqRUNFxqDrG6P0i-Cv","tabs":"_3yVbbH2AD0iYPT3hM4SfGS","bp3-tab-list":"_1Z850HsgzOvEgqiFOcsl93"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tabs/tabs.scss
// module id = 763
// module chunks = 0